import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex flex-col min-w-fit h-fit w-fit" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mb-0.5 min-w-max w-auto flex self-center" }, " Details: ", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-red-500 text-xs pl-1 absolute top-[-5px] flex w-full justify-center"
}
const _hoisted_4 = { class: "detailsGrid min-w-fit pr-2" }
const _hoisted_5 = { class: "font-bold mb-1 w-1/3 h-6 text-center min-w-min pl-2 content-center" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs items-center"
}
const _hoisted_7 = {
  key: 0,
  class: "font-bold w-1/3 text-center min-w-max px-2 h-6"
}
const _hoisted_8 = { class: "detailsGrid min-w-fit" }
const _hoisted_9 = { class: "flex justify-end w-full" }
const _hoisted_10 = { class: "w-full self-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-pencil float-right self-center px-2" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check text-black" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "editTable w-full overflow-visible relative"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, null, -1)

import { ref, onMounted } from 'vue';

import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import AutoComplete from 'primevue/autocomplete';
import InputNumber from 'primevue/inputnumber';
import Calendar from 'primevue/calendar';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import Textarea from 'primevue/textarea';
import Inplace from 'primevue/inplace';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditInformationCard',
  props: ['information', 'membersTotal', 'inputTable', 'tableColumns', 'warning'],
  emits: ['remove'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "faf9e486": (infoLength.length)
}))

const props = __props
const emit = __emit

const information = ref(props.information)
const inputTable = ref(props.inputTable)
const infoLength = { length: props.membersTotal !== undefined ? Object.keys(props.information).length + 1 : Object.keys(props.information).length }

const filteredValues = ref();
const editingRows: any = ref([]);
const editTableHeight = ref('auto')
const editTableHeightNum = ref(0)

onMounted(async () => {
    if (props.inputTable !== undefined)
        setTableHeight()

    Object.keys(information.value).forEach(element => {
        if (Array.isArray(information.value[element].value))
            information.value[element].value = information.value[element].value.join(' ')
    });
})

/**
 * DropDown Search
 */
const dropDownSearch = (event: any, items: any) => {
    setTimeout(() => {
        if (!event.query.trim().length) {
            filteredValues.value = [...items];
        } else {
            filteredValues.value = items.filter((value: string) => {
                return value.toLowerCase().startsWith(event.query.toLowerCase());
            });
        }
    }, 250);
}

const onRowEditComplete = (event: any) => {
    let { newData, index } = event;
    inputTable.value[index] = newData;
};

function addEmptyRowToInfoTable() {
    let tempObject: any = {}
    props.tableColumns.forEach((element: { key: string }) => {
        tempObject[element.key] = ""
    });
    inputTable.value.push(tempObject)
}

/**
 * Manually set datatable root component container to height of table
 */
function setTableHeight() {
    let emptyTableRec = document.getElementsByClassName("p-datatable-wrapper")[3]
    if (emptyTableRec == undefined) {
        emptyTableRec = document.getElementsByClassName("p-datatable-wrapper")[0]
    }
    if (emptyTableRec !== undefined) {
        editTableHeightNum.value = emptyTableRec.getBoundingClientRect().height
        editTableHeight.value = (editTableHeightNum.value).toString() + 'px'
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col self-center lg:min-w-fit border-2 rounded p-2 pt-1 informationContainer h-auto mx-1", inputTable.value !== undefined ? 'infoTable ' : '']),
    style: {"scrollbar-width":"thin"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: _normalizeClass(["flex relative", __props.warning ? 'pt-4' : ''])
      }, [
        (__props.warning)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Please fill in required fields"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(information.value, (info, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              class: "list-none text-base"
            }, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(key) + ": ", 1),
              (!info.required)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(optional)"))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (__props.membersTotal !== undefined)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.membersTotal) + " Members ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(information.value, (info, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              class: "list-none ml-3 text-base relative"
            }, [
              (information.value[key].type == 'dropdown')
                ? (_openBlock(), _createBlock(_unref(Dropdown), {
                    key: 0,
                    modelValue: information.value[key].value,
                    "onUpdate:modelValue": ($event: any) => ((information.value[key].value) = $event),
                    options: information.value[key].options,
                    class: "text-center rounded-md border-2 shadow-none min-w-fit h-6 mb-1 font-semibold text-black-900 w-64"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                : (information.value[key].type == 'autoComplete')
                  ? (_openBlock(), _createBlock(_unref(AutoComplete), {
                      key: 1,
                      dropdown: "",
                      onComplete: ($event: any) => (dropDownSearch($event, information.value[key].options)),
                      modelValue: information.value[key].value,
                      "onUpdate:modelValue": ($event: any) => ((information.value[key].value) = $event),
                      suggestions: filteredValues.value,
                      class: "rounded-md border-2 min-w-fit h-6 mb-1 font-semibold text-black-900 w-64"
                    }, null, 8, ["onComplete", "modelValue", "onUpdate:modelValue", "suggestions"]))
                  : (information.value[key].type == 'inputNumber')
                    ? (_openBlock(), _createBlock(_unref(InputNumber), {
                        key: 2,
                        modelValue: information.value[key].value,
                        "onUpdate:modelValue": ($event: any) => ((information.value[key].value) = $event),
                        minFractionDigits: 0,
                        maxFractionDigits: 8,
                        class: "rounded-md border-2 shadow-none min-w-fit h-6 mb-1 font-semibold text-black-900 w-64"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : (information.value[key].type == 'calendar')
                      ? (_openBlock(), _createBlock(_unref(Calendar), {
                          key: 3,
                          modelValue: information.value[key].value,
                          "onUpdate:modelValue": ($event: any) => ((information.value[key].value) = $event),
                          dateFormat: "yy-mm-dd",
                          currentView: "year",
                          class: "rounded-md border-2 shadow-none min-w-fit h-6 mb-1 font-semibold text-black-900 w-64",
                          showIcon: "",
                          showTime: false
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : (information.value[key].type == 'textarea')
                        ? (_openBlock(), _createBlock(_unref(Inplace), {
                            key: 4,
                            class: "w-max",
                            closable: true,
                            "pt:display:class": "p-0.5 m-0 w-64 h-6 border-2 shadow-none rounded-md flex items-center justify-center text-center"
                          }, {
                            display: _withCtx(() => [
                              _createElementVNode("span", _hoisted_9, [
                                _createElementVNode("span", _hoisted_10, _toDisplayString(information.value[key].value.slice(0, 25)), 1),
                                _hoisted_11
                              ])
                            ]),
                            content: _withCtx(() => [
                              _createVNode(_unref(Textarea), {
                                modelValue: information.value[key].value,
                                "onUpdate:modelValue": ($event: any) => ((information.value[key].value) = $event),
                                cols: "60",
                                rows: "1",
                                autoResize: "",
                                class: "text-left rounded-md border-2 outline-none min-w-fit text-black-900"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            closeicon: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_unref(InputText), {
                            key: 5,
                            modelValue: information.value[key].value,
                            "onUpdate:modelValue": ($event: any) => ((information.value[key].value) = $event),
                            class: "text-center rounded-md border-2 shadow-none min-w-fit h-6 mb-1 font-semibold text-black-900 w-64"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
            ]))
          }), 128))
        ])
      ], 2)
    ]),
    (inputTable.value !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_unref(DataTable), {
            value: inputTable.value,
            pt: {
            wrapper: {
                class: ['text-sm !overflow-visible'],
            },
            root: {
                style: {
                    'height': editTableHeight.value,
                }
            }
        },
            editingRows: editingRows.value,
            "onUpdate:editingRows": _cache[0] || (_cache[0] = ($event: any) => ((editingRows).value = $event)),
            "pt:table:class": "mt-2",
            editMode: "row",
            onRowEditSave: onRowEditComplete
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Column), { pt: { headerCell: { style: { 'min-width': '40px' } } } }, {
                body: _withCtx(({ data }) => [
                  _createVNode(_unref(Button), {
                    icon: "pi pi-trash",
                    class: "hover:bg-gray-200 trash-icon",
                    onClick: ($event: any) => { _ctx.$emit('remove', data); editTableHeightNum.value -= 30.5; editTableHeight.value = editTableHeightNum.value + 'px'}
                  }, null, 8, ["onClick"])
                ]),
                editor: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableColumns, (col) => {
                return (_openBlock(), _createBlock(_unref(Column), {
                  key: col.key,
                  field: col.key,
                  header: col.name.toUpperCase()
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createElementVNode("span", null, _toDisplayString(data[field]), 1)
                  ]),
                  editor: _withCtx(({ data, field }) => [
                    _createVNode(_unref(InputText), {
                      modelValue: data[field],
                      "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
                      pt: {
            root: {
                style: {
                    'min-width': (col.name.length * 10) + 16 + 'px',
                    'box-shadow': '0 0 0 0.1rem #e5e7eb',
                    'padding-left': '2px',
                    'padding-bottom': '2px'
                }
            }
        },
                      style: _normalizeStyle('width:' + (((data[field].length) * 10) + 8) + 'px')
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "pt", "style"])
                  ]),
                  _: 2
                }, 1032, ["field", "header"]))
              }), 128)),
              _createVNode(_unref(Column), {
                rowEditor: true,
                style: {"width":"7%","min-width":"5rem","height":"3px"},
                bodyStyle: "text-align:center"
              })
            ]),
            _: 1
          }, 8, ["value", "pt", "editingRows"]),
          _createVNode(_unref(Button), {
            icon: "pi pi-plus text-green-800",
            class: "hover:bg-gray-200 plus-icon absolute top-3 left-1.5",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {addEmptyRowToInfoTable(); editTableHeightNum.value += 30.5; editTableHeight.value = editTableHeightNum.value + 'px'})
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})